// @ts-strict-ignore
import styled from 'styled-components';

import { colors, transition } from 'theme';

import { ButtonWithStyles } from './ButtonWithStyles';

export const LegacyPrimaryButton = styled(ButtonWithStyles).attrs({
  $textColor: (props) =>
    props.color || (props.reverse ? colors.waterBlue : colors.white),
})<{ $transparent?: boolean }>`
  transition: all ${transition};
  text-decoration: none;
  color: ${(props) => props.$textColor};
  background: ${(props) => (props.reverse ? colors.white : colors.waterBlue)};
  border: 1px solid ${colors.waterBlue};
  ${(props) =>
    props.$transparent &&
    `
  background: transparent;
  border: 1px solid ${colors.white};`}

  &:hover {
    background-color: ${colors.hoverBlue};
    border: 1px solid ${colors.hoverBlue};
    color: ${(props) => props.$textColor};
    text-decoration: none;
  }
  &:disabled {
    &:hover {
      background-color: ${colors.waterBlue};

      ${(props) =>
        props.$transparent &&
        `
  background-color: transparent;
`}
    }
  }
`;
